module.exports = __webpack_public_path__ + "b74a515aa08fd4a1b337e49ef961e005.pdf";